import Cookies from "js-cookie";
import { notice } from "./action/action";
import {
  getCryptoRate,
  getFavoriteGameList,
  getInboxList,
  getMarquee,
  getTransferWallet,
  getUserBalance,
  getUserGameList,
  getUserInfo,
  getVipInfo,
} from "../api/getApi";
import {
  StoreCryptoRatio,
  cleanMemberInfo,
  storeInboxList,
  storeMemberInfo,
  storeTransferWallet,
} from "./action/member/memberAction";
import { startLoading, stopLoading } from "./action/loading/loadingAction";
import { filterGameList } from "./action/game/gameAction";
import i18next from "i18next";
import { flattenWalletObject } from "../utils/flattenObject";

export const apiErrorMessage = (store) => (next) => (action) => {
  if (action.type === "API_ERROR" && action.error) {
    const errorMessage = action.error.response.data.message;
    const errorParams = action.error.response.data.errData;
    store.dispatch(
      notice(
        i18next.t(`backend_response.${errorMessage}`, errorParams),
        "error"
      )
    );
  }
  return next(action);
};

export const userLogout = (store) => (next) => (action) => {
  next(action);
  if (action.type === "USER_LOGOUT") {
    const { dispatch } = store;
    dispatch(notice(i18next.t(`backend_response.Invalid Authorization`), 15));
    dispatch(cleanMemberInfo());
    Cookies.remove("token");
    Cookies.remove("tmpToken");
    setTimeout(() => {
      // action.navigate("/casino");
      window.location.href = "/casino";
    }, 1500);
  }
};

export const getBalance = (store) => (next) => (action) => {
  next(action);
  if (action.type === "GET_BALANCE") {
    const { dispatch, getState } = store;
    const getBalance = async () => {
      try {
        const [getBalanceData] = await Promise.all([getUserBalance()]);
        const { isMemberInfo } = getState();
        dispatch(
          storeMemberInfo({
            ...isMemberInfo,
            vpoint: getBalanceData,
          })
        );
      } catch (err) {
        if (err.code === "ERR_CANCELED") {
          return;
        }
        // dispatch({
        //   type: "USER_LOGOUT",
        //   navigate: action.navigate,
        //   error: err,
        // });
        // dispatch(
        //   notice(
        //     "Your account has been logged in to another location",
        //     "error",
        //     15
        //   )
        // );
        // dispatch(cleanMemberInfo());
        // Cookies.remove("token");
        // setTimeout(() => {
        //   action.navigate("/casino");
        // }, 1500);
      }
    };
    getBalance();
  }
};

export const getMemberData = (store) => (next) => (action) => {
  next(action);
  if (action.type === "GET_MEMBER_DATA") {
    const { dispatch, getState } = store;
    const getMemberData = async () => {
      try {
        const [userInfoData, getUserBalanceData] = await Promise.all([
          getUserInfo(),
          getUserBalance(),
        ]);
        if (userInfoData.code == 200) {
          const { isMemberInfo } = getState();
          dispatch(
            storeMemberInfo({
              ...isMemberInfo,
              ...userInfoData.memberInfo,
              vpoint: getUserBalanceData,
            })
          );
        }
      } catch (err) {}
    };
    getMemberData();
  }
};

export const initializeApi = (store) => (next) => (action) => {
  next(action);
  if (action.type === "INITIALIZE_API") {
    const { dispatch } = store;

    const initializeData = async () => {
      try {
        dispatch(startLoading());
        if (Cookies.get("token") !== undefined) {
          if (Cookies.get("tmpToken")) {
            Cookies.remove("tmpToken");
          }
          Cookies.set("tmpToken", action.tmpToken, { expires: 3 });

          const [
            userInfoData,
            userFavoriteGame,
            userGameList,
            getVipInfoData,
            getUserBalanceData,
            // getTransferWalletData,
            getInboxListData,
          ] = await Promise.all([
            getUserInfo(),
            getFavoriteGameList(),
            getUserGameList(),
            getVipInfo(),
            getUserBalance(),
            // getTransferWallet(),
            getInboxList(),
          ]);

          if (userInfoData.code == 200) {
            dispatch(
              storeMemberInfo({
                ...userInfoData.memberInfo,
              })
            );
          }

          if (userGameList) {
            dispatch(
              filterGameList({
                allGameList: userGameList.gameTypeGroup,
                allGamePlatform: userGameList.platforms,
                allGameType: userGameList.gameType,
                allGame_subtype: userGameList.gameSubType,
                allNewGameList: userGameList.newGames,
                allTopGameList: userGameList.topGames,
                randomlySelectedGames: userGameList.randomlySelectedGames,
                userFavoriteGame: userFavoriteGame.userFavoriteGame,
                exclusiveBrandGames: userGameList.exclusiveBrandGames,
              })
            );
          }

          if (getVipInfoData.code == 200) {
            dispatch(
              storeMemberInfo({
                ...userInfoData.memberInfo,
                vipInfo: getVipInfoData.vipInfo,
                vpoint: getUserBalanceData,
              })
            );
          }

          // if (getTransferWalletData.code == 200) {
          //   dispatch(
          //     storeTransferWallet(
          //       flattenWalletObject(
          //         getTransferWalletData.transferGameWalletInfo
          //       )
          //     )
          //   );
          // }

          if (getInboxListData.code == 200) {
            dispatch(storeInboxList(getInboxListData.data));
          }
        }
      } catch (err) {
        if (err.code === "ERR_CANCELED") {
          return;
        }

        // dispatch({
        //   type: "USER_LOGOUT",
        //   navigate: action.navigate,
        //   error: err,
        // });
        // dispatch(cleanMemberInfo());
        // Cookies.remove("token");
        // setTimeout(() => {
        //   action.navigate("/casino");
        // }, 1500);
      } finally {
        setTimeout(() => {
          dispatch(stopLoading());
        }, 1000);
      }
    };

    initializeData();
  }
};

export const periodicDataUpdater = (store) => (next) => (action) => {
  next(action);
  if (action.type === "UPDATE_DATA_PERIODICALLY") {
    const { dispatch } = store;

    const updaterData = async () => {
      try {
        if (Cookies.get("token") !== undefined) {
          const [
            userInfoData,
            // cryptoRatioData,
            getVipInfoData,
            getUserBalanceData,
          ] = await Promise.all([
            getUserInfo(),
            // getCryptoRate(),
            getVipInfo(),
            getUserBalance(),
          ]);
          // if (cryptoRatioData) {
          //   dispatch(StoreCryptoRatio(cryptoRatioData));
          // }

          if (userInfoData.code == 200) {
            dispatch(
              storeMemberInfo({
                ...userInfoData.memberInfo,
              })
            );
          }

          if (getVipInfoData.code == 200) {
            dispatch(
              storeMemberInfo({
                ...userInfoData.memberInfo,
                vipInfo: getVipInfoData.vipInfo,
                vpoint: getUserBalanceData,
              })
            );
          }
        }
      } catch (err) {
        if (err.code === "ERR_CANCELED") {
          return;
        }
        // dispatch({
        //   type: "USER_LOGOUT",
        //   navigate: action.navigate,
        //   error: err,
        // });
        // dispatch(
        //   notice(
        //     "Your account has been logged in to another location",
        //     "error",
        //     15
        //   )
        // );
        // dispatch(cleanMemberInfo());
        // Cookies.remove("token");
        // setTimeout(() => {
        //   action.navigate("/casino");
        // }, 1500);
      }
    };
    updaterData();
  }
};
